// extracted by mini-css-extract-plugin
module.exports = {"root":"Text_root__18Msu","header":"Text_header__1jlmx","subheader":"Text_subheader__guOJF"};